var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selecting)?_c('rect',{staticClass:"selection-area",attrs:{"x":Math.min(_vm.start.x, _vm.current.x) - 0.5,"y":Math.min(_vm.start.y, _vm.current.y) - 0.5,"width":Math.abs(_vm.start.x - _vm.current.x),"height":Math.abs(_vm.start.y - _vm.current.y)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }